import { App } from "./components/app";
import { render } from "react-dom";

render(<App />, document.getElementById("app"));
